'use strict';

var _ = require('lodash');
var AlertsPanelAggregationFactory = function AlertsPanelAggregationFactory(DataAggregationFactory) {
  function AlertsPanelAggregation() {
    DataAggregationFactory.call(this, 'market-dashboard', 'dashboard-alerts-panel');
  }
  function sortScoreDesc(alertObj) {
    return 1 / alertObj.score;
  }
  function getEntryKey(entry) {
    //key without POS - unflatten for Cabin alerts
    return entry.carrier + entry.market + entry.month + entry.year;
  }
  function hasEntryCabinAlerts(entry) {
    return _.isObject(entry.cabinAlerts) && _.isObject(entry.cabinAlerts.alerts);
  }
  function hasEntryPOSAlerts(entry) {
    return _.isObject(entry.posAlerts);
  }
  function addAlertScore(target) {
    return function (score, technicalId) {
      if (target[technicalId]) {
        target[technicalId] += score;
      } else {
        target[technicalId] = score;
      }
    };
  }
  function addAlertsScores(allAlerts, entryAlerts) {
    _.forOwn(entryAlerts, addAlertScore(allAlerts));
    return allAlerts;
  }
  function unFlattenByPOS(result, entry) {
    result[getEntryKey(entry)] = entry.cabinAlerts.alerts;
    return result;
  }
  function transformAlerts(result, value, key) {
    result.push({
      technicalId: key,
      score: value
    });
    return result;
  }
  function aggregateCabinAlerts(data) {
    return _.chain(data).filter(hasEntryCabinAlerts).reduce(unFlattenByPOS, {}).reduce(addAlertsScores, {}).reduce(transformAlerts, []).sortBy(sortScoreDesc).value();
  }
  function aggregatePOSAlerts(data) {
    return _.chain(data).filter(hasEntryPOSAlerts).reduce(function (result, entry) {
      return addAlertsScores(result, entry.posAlerts);
    }, {}).reduce(transformAlerts, []).sortBy(sortScoreDesc).value();
  }
  AlertsPanelAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  AlertsPanelAggregation.constructor = AlertsPanelAggregation;
  AlertsPanelAggregation.prototype.aggregate = function (data) {
    var aggregated = {
      flightAlerts: aggregateCabinAlerts(data),
      marketAlerts: aggregatePOSAlerts(data)
    };
    aggregated.totalNumber = aggregated.flightAlerts.length + aggregated.marketAlerts.length;
    return aggregated;
  };
  return AlertsPanelAggregation;
};
AlertsPanelAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = AlertsPanelAggregationFactory;